import { createStore } from 'vuex'

export default createStore({
  state: {
    carrinho: []
  },
  getters: {
    // Getter para calcular o total de itens no carrinho
    totalItens: state => {
      return state.carrinho.reduce((total, item) => total + Number(item.quantidade), 0)
    },
    // Getter para calcular o valor total do carrinho
    valorTotal: state => {
      return state.carrinho.reduce((total, item) => total + (item.precoUnitario * item.quantidade), 0)
    }
  },
  mutations: {
    adicionarAoCarrinho(state, item) {
      // Verifica se o produto já está no carrinho com a MESMA COR e TAMANHO
      const itemExistente = state.carrinho.find(i =>
        i.produto.id === item.produto.id &&
        i.cor.id === item.cor.id &&
        i.tamanho.id === item.tamanho.id
      )
      
      if (itemExistente) {
        // Converte as quantidades para número antes de somar para evitar concatenação de strings
        itemExistente.quantidade = Number(itemExistente.quantidade) + Number(item.quantidade)
      } else {
        // Certifica-se que a quantidade seja um número
        item.quantidade = Number(item.quantidade)
        state.carrinho.push(item)
      }
      
      // Salva no localStorage
      localStorage.setItem('carrinho', JSON.stringify(state.carrinho))
    },
    atualizarQuantidade(state, { index, quantidade }) {
      // Nova mutação para atualizar quantidade diretamente
      if (index >= 0 && index < state.carrinho.length) {
        state.carrinho[index].quantidade = quantidade
        localStorage.setItem('carrinho', JSON.stringify(state.carrinho))
      }
    },
    removerDoCarrinho(state, index) {
      state.carrinho.splice(index, 1)
      localStorage.setItem('carrinho', JSON.stringify(state.carrinho))
    },
    limparCarrinho(state) {
      state.carrinho = []
      localStorage.removeItem('carrinho')
    },
    carregarCarrinho(state) {
      const carrinhoSalvo = localStorage.getItem('carrinho')
      if (carrinhoSalvo) {
        state.carrinho = JSON.parse(carrinhoSalvo)
      }
    }
  }
})